export enum ModalidadeAudiencia {
    Presencial = "1",
    Teleaudiencia = "2"
}